import React, { useState } from "react";
import {
  decrypt,
  encrypt,
  toAbsoluteUrl,
  toasterrormsg,
  toastsuccessmsg,
} from "../../helpers/Reusable";
import {
  Link,
  Outlet,
  useLocation,
  useNavigate,
} from "react-router-dom";
import AuthBg from "./AuthBg";
import * as Yup from "yup";
import { useFormik } from "formik";
import { apiHeader, postData } from "../../helpers/ApiHelper";
import ClipLoader from "react-spinners/ClipLoader";
import { FaEye, FaEyeSlash } from "react-icons/fa6";
import { ToastContainer } from "react-toastify";
import { getCookie, setCookie } from "../../helpers/CookieComponent";

// Formik InitialValues
const initialValues = {
  password: "",
  confirmPassword: "",
};

// Fromik Validation Schema
const schema = Yup.object().shape({
  password: Yup.string()
    // .matches(
    //   /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{12,}$/,
    //   "Password Must Be At Least 12 Characters Long, Include One Uppercase Letter, One Lowercase Letter, One Number, And One Special Character"
    // )
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()?"])[A-Za-z\d!@#$%^&*()?"]{12,}$/,
      "Please ensure your password is at least 12 characters long and includes a mix of uppercase and lowercase letters, numbers, and special characters (! “ ? $ % ^ &).Avoid using common words, personal information, or easily guessed patterns"
    )
    .required("Password is required"),
  confirmPassword: Yup.string()
    .required("Confirm password is required")
    .oneOf([Yup.ref("password")], "Password must match"),
});

const ResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [isPasswordShow, setIsPasswordShow] = useState(false);
  const [isConfirmPasswordShow, setIsConfirmPasswordShow] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const rpt = searchParams.get("rpt");

  console.log("rpt+++", rpt);

  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);

      const param = {
        resetPasswordToken: rpt,
        password: values.password,
      };

      const response = await postData(
        "user/reset/password",
        param,
        apiHeader(false)
      );
      
      console.log(response);

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        setTimeout(() => {
          setLoading(false);
          navigate("/login");
          resetForm();
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoading(false);
      }
    },
  });

  return (
    <>
      <ToastContainer />
      <div className="flex flex-col lg:flex-row lg:justify-end lg:min-h-[85vh] xl:min-h-screen h-max">
        {/* Background Section */}
        <div className="h-auto lg:h-screen z-[1] relative lg:fixed top-0 left-0 lg:w-[40%]">
          <AuthBg />
        </div>
        <div className="lg:w-[60%] py-[5%] px-[5%] md:px-[10%] bg-yellow">
          <div className="flex flex-col lg:flex-row w-full p-10">
            <div className="flex items-center justify-center flex-col lg:flex-row w-full">
              <div className="w-full lg:w-[500px]">
                <h1 className="mb-[3rem] lg:mb-[7rem] auth-title-y">
                  Reset password
                </h1>
                <form onSubmit={formik.handleSubmit}>
                  <div className="w-full flex flex-col gap-[2rem] mb-[5rem] lg:mb-[7rem]">
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full auth-input-label mb-4 required"
                      >
                        New password
                      </label>
                      <div className="w-full relative">
                        <input
                          className="w-full auth-input"
                          type={isPasswordShow ? "text" : "password"}
                          placeholder="Enter new password"
                          id="password"
                          value={formik.values.password}
                          onChange={formik.handleChange}
                        />
                        {isPasswordShow == true ? (
                          <FaEyeSlash
                            onClick={() => setIsPasswordShow(false)}
                            className="absolute cursor-pointer top-[2rem] right-[2.5rem] auth-input-eye"
                          />
                        ) : (
                          <FaEye
                            onClick={() => setIsPasswordShow(true)}
                            className="absolute cursor-pointer top-[2rem] right-[2.5rem] auth-input-eye"
                          />
                        )}
                      </div>
                      {formik.touched.password && formik.errors.password && (
                        <div className="mt-2 error-msg">
                          <div className="">{formik.errors.password}</div>
                        </div>
                      )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full auth-input-label mb-4 required"
                      >
                        Confirm new password
                      </label>
                      <div className="w-full relative">
                        <input
                          className="w-full auth-input"
                          type={isConfirmPasswordShow ? "text" : "password"}
                          placeholder="Enter confirm new password"
                          id="confirmPassword"
                          value={formik.values.confirmPassword}
                          onChange={formik.handleChange}
                        />
                        {isConfirmPasswordShow == true ? (
                          <FaEyeSlash
                            onClick={() => setIsConfirmPasswordShow(false)}
                            className="absolute cursor-pointer top-[2rem] right-[2.5rem] auth-input-eye"
                          />
                        ) : (
                          <FaEye
                            onClick={() => setIsConfirmPasswordShow(true)}
                            className="absolute cursor-pointer top-[2rem] right-[2.5rem] auth-input-eye"
                          />
                        )}
                      </div>
                      {formik.touched.confirmPassword &&
                        formik.errors.confirmPassword && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formik.errors.confirmPassword}
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="w-full justify-center lg:justify-start gap-5 flex">
                    <button
                      type="submit"
                      className="btn-auth"
                      disabled={loading}
                    >
                      {!loading && <>Reset password</>}
                      {loading && (
                        <div className="flex items-center gap-3">
                          <span className="" style={{ display: "block" }}>
                            Please wait...{" "}
                          </span>
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loading}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
